import groq from "groq";
import productGroupFields from "./productGroupFields";
import contentBlocks from "./contentBlocks";
import { applyFrench } from "@lib/applyFrenchField";

const internalLink = `
    _type == "internalLink" => {
        "type": @->_type,
        "slug": @->slug,
        "handle": @->store.slug.current,
        "id": @->_id,
        "productGroup": *[_type == "product" && ^->_id == _id] {
            "data": *[_type=='productPage' && references(^._id) ] {
                ${productGroupFields}
            }
        }[0],
    }
`;

const description = `${applyFrench(
  `description[] {
        ...,
        markDefs[]{ ..., ${internalLink}}
    }`,
  `description_fr.portableText[] {
        ...,
        markDefs[]{ ..., ${internalLink}}
    }`
)}`;

const fitDescription = `${applyFrench(
  `fitDescription[] {
        ...,
        markDefs[]{ ..., ${internalLink}}
    }`,
  `fitDescription_fr.portableText[] {
        ...,
        markDefs[]{ ..., ${internalLink}}
    }`
)}`;

const bundleLinks = `${applyFrench(
  `bundleLinks[] {
        ...,
        markDefs[]{ ..., ${internalLink} }
    }`,
  `bundleLinks_fr.portableText[] {
        ...,
        markDefs[]{ ..., ${internalLink} }
    }`
)}`;

const details = `details[] {
    "detailTitle": ${applyFrench("detailTitle", "detailTitle_fr")},
    "detailContent": ${applyFrench("detailContent", "detailContent_fr.accordionText")},
}`;

const measurementDescription = `${applyFrench(
  `measurementDescription[] {
        ...
    }`,
  `measurementDescription_fr.portableText[] {
        ...
    }`
)}`;

const productBySlug = () => groq`
*[_type == "productPage" && slug.current == $slug] | order(_updatedAt desc) {
    "key": _id,
    "title": ${applyFrench("title", "title_fr")},
    slug,
    "description": ${description},
    "bundleLinks": ${bundleLinks},
    "details": ${details},
    "specialNotes": ${applyFrench("specialNotes", "specialNotes_fr")},
    deadstock-> {
        from,
        to,
        toLabel
    },
    sizeGuide {
        "fitDescription": ${fitDescription},
        body {
            ...,
            "title": ${applyFrench("title", "title_fr")},
            "data": sizeChartReference->chart.data {
                ...,
            },
            "img": sizeChartReference->bodyImage {
                ...,
                "altText": ${applyFrench("altText", "altText_fr")}
            },
            "measurementDescription": ${measurementDescription},
        },
        garment {
            ...,
            "title": ${applyFrench("title", "title_fr")},
            "garmentImage": {
                ...,
                "altText": ${applyFrench("altText", "altText_fr")}
            },
            "measurementDescription": ${measurementDescription},
        }
    },
    shopifyProducts[] {
        productColour -> {
            ...,
            "title": ${applyFrench("title", "title_fr")},
        },
        productReferenceV2 -> {
            ...,
        },
        waitlistMessage,
        waitlistMessage_fr,
        styledWith {
            ...,
            products[] {
                productColour -> {
                    ...,
                },
                productReferenceV2 -> {
                    ...,
                }
            },
        }
    },
    ${contentBlocks},
    openGraphImage,
    seoTitle,
    seoDescription,
    seoTwitterCardStyle,
}[0]`;

export default productBySlug;
